import { render, staticRenderFns } from "./MisbehavingVehicles.vue?vue&type=template&id=47eb7d6e&scoped=true&"
import script from "./MisbehavingVehicles.vue?vue&type=script&lang=ts&"
export * from "./MisbehavingVehicles.vue?vue&type=script&lang=ts&"
import style0 from "./MisbehavingVehicles.vue?vue&type=style&index=0&id=47eb7d6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb7d6e",
  null
  
)

export default component.exports